import { FC } from 'react'

import styles from './SectionFooterSeparator.module.scss'

const SectionFooterSeparator: FC<{ color?: string }> = ({ color = '#00ffab' }) => (
  <div
    className={styles.SectionFooterSeparator}
    style={{
      backgroundImage: `repeating-linear-gradient(-45deg,
        transparent,
        transparent 20px,
        ${color} 20px,
        ${color} 35px)`,
    }}
  />
)

export default SectionFooterSeparator
